import {StyleSheet} from 'react-native';
import {Colors} from '../../constants/Colors';

export const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    backgroundColor: Colors.translucid,
    borderRadius: 50,
    height: 40,
    paddingRight: 12,
  },
  image: {marginHorizontal: 12},
  input: {
    fontFamily: 'TCCC-UnityHeadline Regular',
    fontSize: 10,
    lineHeight: 12,
    width: '80%',
    color: Colors.GrayPallete.lightgrayThree,
  },
  inputWithOkButton: {
    width: 'auto',
    flex: 1,
  },
  okButton: {
    backgroundColor: Colors.RedPallete.red,
    borderRadius: 50,
    paddingHorizontal: 14,
    height: 28,
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: 8,
  },
  okButtonText: {
    fontFamily: 'TCCC-UnityHeadline Regular',
    fontSize: 11,
    lineHeight: 13,
    fontWeight: 'bold',
    color: Colors.GrayPallete.lightGrayFive,
    includeFontPadding: false,
  },
});
